import {
	SYSTEM_UNIT_TYPE,
	inspectionFieldsSystemUnitType,
	wsa05InspectionFieldsSystemUnitType,
	defectUnitType,
} from './unitsMappingValues';
import { RECORD_TYPE } from '../choiceListMapping';
import { InspectionStandard } from '@Types';

export const getFieldSystemUnitType = (
	recordType: string,
	field: string,
	inspectionStandard?: string,
): string => {
	switch (recordType) {
		case RECORD_TYPE.INSPECTION:
			switch (inspectionStandard ?? '') {
				case InspectionStandard.WSA05:
					return wsa05InspectionFieldsSystemUnitType[field]
						? wsa05InspectionFieldsSystemUnitType[field]
						: SYSTEM_UNIT_TYPE.LENGTH_LONG;
					break;
				default:
					return inspectionFieldsSystemUnitType[field]
						? inspectionFieldsSystemUnitType[field]
						: SYSTEM_UNIT_TYPE.LENGTH;
			}
		case RECORD_TYPE.DEFECT_FILTER:
			return defectUnitType[field]
				? defectUnitType[field]
				: SYSTEM_UNIT_TYPE.LENGTH;
		default:
			return SYSTEM_UNIT_TYPE.LENGTH;
	}
};
